import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';

import fr from 'facet-rest';
import DialogContentPicker from 'Components/Modals/IdentityVerificationReviewDetails/DialogContentPicker';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  useIdentityVerificationReviewsContext,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/IdentityVerificationReviewsContext';
import DialogContent from '@material-ui/core/DialogContent';

const styles = (theme) => ({
  root: {},
  paper: {
    width: theme.dimensions.xl + 100,
    height: theme.dimensions.xl + 100,
    borderRadius: theme.radius.md,
  },
});

const IdentityVerificationReviewDetailsDialog = ({
  className,
  classes,
  show,
  closeModal,
  resource,
}) => {
  const [currentStepResource, setCurrentStepResource] = useState({});
  const { displayErrorMessage } = useSnackbarContext();
  const { refreshIdentityVerificationReviewsCollection } = useIdentityVerificationReviewsContext();

  useEffect(() => {
    setCurrentStepResource(resource);
  }, [resource]);

  const onDecisionMade = async (link) => {
    try {
      const [decisionResource] = await fr.http.get(link);
      setCurrentStepResource(decisionResource);
    } catch (e) {
      displayErrorMessage(e);
    }
  };

  const onReopen = async (link) => {
    try {
      const [decisionResource] = await fr.http.get(link);
      await decisionResource.submit();
      closeModal();
    } catch (e) {
      displayErrorMessage(e);
    }
  };

  const onDecisionSubmitted = async () => {
    closeModal();
    refreshIdentityVerificationReviewsCollection();
  };

  const onBack = async (decisionResource) => {
    const [reviewResource] = await decisionResource.relationship(fr.relationships.identityVerificationReview.name).link('related').get();
    setCurrentStepResource(reviewResource);
  };

  return (
    <Dialog
      className={classNames(classes.root, className)}
      disableEnforceFocus
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
      onClose={closeModal}
      open={show}
      variant="modern"
      fullScreen
    >
      <DialogContent>
        <DialogContentPicker
          resource={currentStepResource}
          onDecisionMade={onDecisionMade}
          onReopen={onReopen}
          onDecisionSubmitted={onDecisionSubmitted}
          onBack={onBack}
        />
      </DialogContent>

    </Dialog>
  );
};

IdentityVerificationReviewDetailsDialog.defaultProps = {
  className: '',
};

IdentityVerificationReviewDetailsDialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(IdentityVerificationReviewDetailsDialog);
